import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createWidget } from '@beep/sberpay-widget';
import { sberPaymentRequest } from "../../../api/requests/sber";
import { PAY_BTN_STATUSES } from "../../../constants/payment";
import { getIsAuth, getPaymentSumInKopeikas, getUserNumber } from "../../common/selectors";
import { getSberPayBinding, getSberSdkEnabled } from "./selectors";
import { sberPaySlice } from "./slice";
var ERROR_CODES = ['fail', 'cancel', 'closed'];
var SUCCESS_CODES = ['success'];
var SBER_SDK_ENV = 'PRODUCTION';

/* TODO: refactor */
var sberPayDataAction = function sberPayDataAction(userCtn, fromCtn, captcha) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getSberPayBinding;
      var state, paymentSum, isAuth, userNumber, bindingId, widget, shouldOpenSberWidget, _yield$sberPaymentReq, data, isCaptchaError, _err$response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch(sberPaySlice.actions.setPaymentStatus(PAY_BTN_STATUSES.pending));
            state = getState();
            paymentSum = getPaymentSumInKopeikas(state);
            isAuth = getIsAuth(state);
            userNumber = getUserNumber(state);
            bindingId = (_getSberPayBinding = getSberPayBinding(state)) === null || _getSberPayBinding === void 0 ? void 0 : _getSberPayBinding.bindingId;
            widget = createWidget(SBER_SDK_ENV);
            shouldOpenSberWidget = getSberSdkEnabled(state);
            _context.prev = 8;
            _context.next = 11;
            return sberPaymentRequest(userCtn, fromCtn = bindingId ? userNumber : fromCtn, isAuth ? bindingId : null, paymentSum, captcha);
          case 11:
            _yield$sberPaymentReq = _context.sent;
            data = _yield$sberPaymentReq.data;
            isCaptchaError = _yield$sberPaymentReq.isCaptchaError;
            if (!isCaptchaError) {
              _context.next = 18;
              break;
            }
            dispatch(sberPaySlice.actions.setPaymentStatus(PAY_BTN_STATUSES.initial));
            dispatch(sberPaySlice.actions.setHasCaptchaError(true));
            return _context.abrupt("return");
          case 18:
            if (data) {
              _context.next = 20;
              break;
            }
            throw new Error('Response is empty');
          case 20:
            if (shouldOpenSberWidget && (!bindingId || !isAuth)) {
              widget.open({
                bankInvoiceId: data.sbolBankInvoiceId || data.orderId,
                backUrl: window.location.href // FIXME: Вызывает перезагрузку страницы в последней версии СДК, которая не ходит в другое окно
              }).then(function (res) {
                if (ERROR_CODES.includes(res)) {
                  throw Error();
                }
                if (SUCCESS_CODES.includes(res)) {
                  return dispatch(sberPaySlice.actions.setPaymentStatus(PAY_BTN_STATUSES.success));
                }
                return data;
              }).catch(function (error) {
                dispatch(sberPaySlice.actions.setErrorText(error.message || null));
                dispatch(sberPaySlice.actions.setPaymentStatus(PAY_BTN_STATUSES.error));
              });
            } else {
              dispatch(sberPaySlice.actions.setSberPayId(data.id));
            }
            _context.next = 27;
            break;
          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](8);
            dispatch(sberPaySlice.actions.setErrorText((_context.t0 === null || _context.t0 === void 0 || (_err$response = _context.t0.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.message) || null));
            dispatch(sberPaySlice.actions.setPaymentStatus(PAY_BTN_STATUSES.error));
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[8, 23]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var resetPayIdAction = function resetPayIdAction() {
  return function (dispatch) {
    dispatch(sberPaySlice.actions.setSberPayId(null));
  };
};
var closeProcessModalAction = function closeProcessModalAction() {
  return function (dispatch) {
    dispatch(sberActions.setUnBinded(false));
    // dispatch(resetPayIdAction());
    // dispatch(sberPaySlice.actions.setPaymentStatus(PAY_BTN_STATUSES.initial));
  };
};
export var sberActions = _objectSpread(_objectSpread({}, sberPaySlice.actions), {}, {
  resetPayIdAction: resetPayIdAction,
  sberPayDataAction: sberPayDataAction,
  closeProcessModalAction: closeProcessModalAction
});